import React from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeader,
    Badge,
} from "../../../components/ui";

const thClass =
    "px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";

export function UnitList({ units, onOpenUnitModal }) {
    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                {onOpenUnitModal && (
                    <button
                        type="button"
                        onClick={() => onOpenUnitModal({})}
                        className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-green-700"
                    >
                        <i className="fas fa-plus" aria-hidden="true" />
                        Agregar Nueva Unidad
                    </button>
                )}
                <Badge variant="primary" className="w-fit px-3 py-1 sm:ml-auto">
                    <i className="fas fa-list mr-1" aria-hidden="true" />
                    {units.length} {units.length === 1 ? "unidad" : "unidades"}
                </Badge>
            </div>

            <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
                <Table className="text-sm">
                    <TableHead>
                        <tr>
                            <TableHeader className={`${thClass} w-24 text-center`}>
                                <i className="fas fa-hashtag mr-1" aria-hidden="true" />
                                Código
                            </TableHeader>
                            <TableHeader className={`${thClass} w-28 text-center`}>
                                <i className="fas fa-cube mr-1" aria-hidden="true" />
                                Nombre
                            </TableHeader>
                            <TableHeader className={thClass}>
                                <i className="fas fa-info-circle mr-1" aria-hidden="true" />
                                Descripción
                            </TableHeader>
                        </tr>
                    </TableHead>
                    <TableBody>
                        {units.length > 0 ? (
                            units.map((item, index) => (
                                <TableRow key={index} hover>
                                    <TableCell align="center">
                                        <span className="inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                                            {item.unitID}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Badge variant="primary" className="px-2 py-0.5 text-xs">
                                            {item.unitName}
                                        </Badge>
                                    </TableCell>
                                    <TableCell>{item.unitDescription}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={3}
                                    align="center"
                                    className="py-10 text-gray-500 dark:text-gray-400"
                                >
                                    <i
                                        className="fas fa-inbox mb-2 text-3xl"
                                        aria-hidden="true"
                                    />
                                    <p className="mb-1 font-medium">
                                        No hay unidades registradas
                                    </p>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
